// Adapted from ds/src/app/layouts/Sideblock/Profile.tsx
// Uses DS Avatar/Popover UI components wired to HalfNote's auth context.
import { Popover, PopoverButton, PopoverPanel, Transition } from '@headlessui/react';
import { ArrowLeftStartOnRectangleIcon } from '@heroicons/react/24/outline';

import { Avatar, Button } from '@lib/ui';
import { useAuthContext } from '@lib/auth';

export function Profile() {
  const { user, logout } = useAuthContext();

  const initials = user?.name
    ? user.name
        .split(' ')
        .map((n) => n[0])
        .join('')
        .toUpperCase()
        .slice(0, 2)
    : (user?.email?.slice(0, 2).toUpperCase() ?? '??');

  return (
    <Popover className="relative flex">
      <PopoverButton
        as={Avatar}
        size="sm"
        role="button"
        name={initials}
        indicator={
          <span className="absolute bottom-0 right-0 size-2.5 rounded-full border-2 border-white bg-green-500 dark:border-dark-700" />
        }
        className="cursor-pointer"
      />
      <Transition
        enter="duration-200 ease-out"
        enterFrom="translate-y-2 opacity-0"
        enterTo="translate-y-0 opacity-100"
        leave="duration-200 ease-out"
        leaveFrom="translate-y-0 opacity-100"
        leaveTo="translate-y-2 opacity-0"
      >
        <PopoverPanel
          anchor={{ to: 'bottom end', gap: 12 }}
          className="border-gray-150 shadow-soft dark:border-dark-600 dark:bg-dark-700 z-70 flex w-64 flex-col rounded-lg border bg-white transition dark:shadow-none"
        >
          {({ close }: { close: () => void }) => (
            <>
              <div className="dark:bg-dark-800 flex items-center gap-4 rounded-t-lg bg-gray-100 px-4 py-5">
                <Avatar size="lg" name={initials} />
                <div>
                  <p className="dark:text-dark-100 text-base font-medium text-gray-700">
                    {user?.name || 'User'}
                  </p>
                  <p className="dark:text-dark-300 mt-0.5 text-xs text-gray-400">{user?.email}</p>
                </div>
              </div>
              <div className="flex flex-col pt-2 pb-5">
                <div className="px-4 pt-4">
                  <Button
                    className="w-full gap-2"
                    onClick={() => {
                      close();
                      logout();
                    }}
                  >
                    <ArrowLeftStartOnRectangleIcon className="size-4.5" />
                    <span>Logout</span>
                  </Button>
                </div>
              </div>
            </>
          )}
        </PopoverPanel>
      </Transition>
    </Popover>
  );
}
